import App from "./App.svelte";

const app = new App({
  target: document.getElementById("root")
//  ,props: { afs: window.afs, products: window.products}
});

//console.log("App, target", app, target);

export default app;
